import { render, staticRenderFns } from "./SupplementaryAccount.vue?vue&type=template&id=9a5f5688&scoped=true"
import script from "./SupplementaryAccount.vue?vue&type=script&lang=js"
export * from "./SupplementaryAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5f5688",
  null
  
)

export default component.exports